import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1280.000000 1280.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M5847 8233 c-20 -49 -72 -180 -116 -293 -44 -113 -107 -275 -141
-360 -34 -85 -74 -189 -90 -230 -15 -41 -35 -92 -44 -112 -9 -21 -16 -40 -16
-43 0 -3 57 -4 127 -3 l127 3 28 75 c15 41 35 90 43 108 l15 32 221 -2 221 -3
36 -100 c19 -55 40 -103 46 -107 11 -8 256 -11 256 -4 0 2 -61 157 -136 343
-75 186 -175 433 -221 548 -47 116 -87 216 -90 223 -4 8 -37 12 -118 12 l-112
0 -36 -87z m227 -417 c36 -99 66 -183 66 -188 0 -4 -66 -8 -146 -8 -135 0
-146 1 -139 18 4 9 33 89 65 177 75 206 71 198 80 188 4 -4 37 -89 74 -187z"
          />
          <path
            d="M6360 8309 c0 -5 48 -92 107 -192 58 -100 121 -207 138 -237 17 -30
54 -91 81 -135 l49 -80 5 -235 5 -235 120 0 120 0 5 236 c3 156 9 241 16 250
7 8 42 65 78 127 36 61 96 163 133 225 108 183 163 278 163 283 0 2 -56 4
-124 4 -87 0 -127 -4 -134 -12 -5 -7 -62 -105 -127 -218 -64 -113 -121 -209
-125 -213 -4 -4 -65 93 -136 217 l-129 226 -122 0 c-80 0 -123 -4 -123 -11z"
          />
          <path
            d="M7479 8294 c0 -10 -1 -57 0 -103 0 -88 9 -106 44 -95 17 5 45 0 187
-33 75 -18 229 -91 286 -136 144 -115 273 -288 310 -417 9 -30 20 -62 24 -71
10 -19 27 -107 35 -181 l6 -58 100 0 99 0 -1 58 c-3 293 -191 645 -439 824
-25 18 -47 35 -50 38 -14 15 -121 70 -246 125 -43 20 -200 54 -283 61 -65 6
-71 5 -72 -12z"
          />
          <path
            d="M7479 7883 c-1 -21 -3 -61 -4 -90 -1 -28 1 -57 6 -64 4 -7 33 -16 65
-20 56 -8 75 -15 179 -67 57 -28 154 -125 190 -190 26 -46 61 -153 70 -214 l6
-38 101 0 100 0 -6 74 c-8 100 -72 272 -125 340 -76 95 -167 174 -260 225 -79
43 -202 81 -263 81 l-58 0 -1 -37z"
          />
          <path
            d="M7560 7469 c-132 -59 -90 -269 54 -269 41 0 114 41 122 68 3 9 10 25
15 34 25 48 -9 135 -63 161 -57 27 -81 28 -128 6z"
          />
          <path
            d="M3902 7026 c-185 -45 -342 -193 -403 -378 -20 -62 -24 -92 -23 -198
1 -139 19 -205 85 -316 100 -166 318 -275 521 -260 91 6 213 45 273 86 97 67
180 177 216 287 29 87 35 83 -100 83 l-119 0 -26 -55 c-48 -97 -135 -154 -258
-171 -34 -5 -66 0 -119 16 -63 19 -81 30 -130 80 -74 76 -101 144 -102 255 -1
150 66 264 193 327 66 33 215 32 280 -1 53 -27 113 -88 141 -142 l19 -39 120
0 c66 0 120 1 120 3 0 2 -7 27 -16 57 -52 174 -203 319 -381 365 -69 18 -218
18 -291 1z"
          />
          <path
            d="M8578 7024 c-137 -33 -286 -141 -357 -259 -37 -61 -80 -195 -82 -254
-1 -26 -5 -15 -15 39 -18 100 -38 152 -91 233 -76 116 -215 202 -363 226 -36
6 -170 11 -297 11 l-233 0 0 -560 0 -560 253 0 c281 0 330 7 444 62 84 41 185
139 230 223 19 36 39 98 50 152 l19 91 12 -76 c33 -214 195 -392 417 -458 82
-25 258 -25 340 0 265 79 425 292 425 567 0 167 -52 294 -169 409 -123 121
-249 170 -431 169 -52 0 -121 -7 -152 -15z m236 -219 c91 -15 195 -96 236
-183 88 -186 13 -406 -165 -489 -50 -23 -73 -28 -140 -28 -95 0 -144 13 -209
57 -97 63 -150 169 -150 298 -1 186 123 328 309 353 31 4 53 3 119 -8z m-1098
-47 c62 -33 109 -84 140 -155 19 -43 24 -71 24 -138 0 -149 -60 -254 -178
-312 -51 -25 -69 -28 -189 -31 l-133 -4 0 338 0 339 142 -5 c129 -5 148 -9
194 -32z"
          />
          <path
            d="M4647 7014 c-3 -4 -6 -256 -7 -560 l0 -554 125 0 125 0 0 230 0 230
210 0 210 0 0 -230 0 -230 120 0 120 0 0 560 0 561 -117 -3 -118 -3 -3 -212
-2 -213 -210 0 -210 0 -2 213 -3 212 -116 3 c-63 1 -118 0 -122 -4z"
          />
          <path
            d="M5690 6867 c0 -85 -3 -337 -7 -561 l-6 -407 122 3 122 3 0 545 c0
300 0 551 -1 558 0 9 -30 12 -115 12 l-115 0 0 -153z"
          />
          <path
            d="M6060 6460 l0 -560 120 0 120 0 2 345 3 346 70 -97 c39 -54 84 -117
100 -140 17 -23 97 -135 180 -248 l150 -206 102 0 103 0 0 560 0 561 -117 -3
-118 -3 -5 -335 -5 -334 -31 39 c-17 22 -65 87 -105 145 -41 58 -136 192 -213
298 l-138 192 -109 0 -109 0 0 -560z"
          />
          <path
            d="M4635 5708 c-3 -7 -4 -258 -3 -558 l3 -545 270 0 c233 1 278 3 330
19 206 63 358 241 385 454 20 150 -13 296 -91 407 -78 112 -171 176 -309 214
-66 19 -102 21 -328 21 -193 0 -254 -3 -257 -12z m555 -239 c77 -36 111 -68
151 -141 32 -60 34 -68 34 -163 -1 -126 -23 -183 -101 -254 -71 -65 -122 -82
-271 -88 -111 -5 -121 -4 -125 12 -1 10 -2 164 0 343 l3 324 127 -4 c110 -3
134 -7 182 -29z"
          />
          <path
            d="M5948 5652 c-23 -58 -159 -404 -342 -872 -30 -74 -57 -145 -60 -158
l-8 -23 128 3 127 3 37 100 37 100 225 3 226 2 38 -105 39 -105 133 0 132 0
-16 38 c-20 47 -169 413 -244 602 -32 80 -89 220 -126 313 l-67 167 -116 0
-116 0 -27 -68z m221 -432 c38 -102 66 -188 64 -192 -7 -12 -283 -10 -283 2 0
10 54 163 104 295 13 33 27 69 31 80 4 11 9 16 11 10 2 -5 35 -93 73 -195z"
          />
          <path
            d="M6474 5707 c-3 -8 -3 -56 -2 -108 l3 -94 155 -5 155 -5 3 -447 2
-448 120 0 120 0 0 450 0 450 155 0 155 0 0 110 0 110 -430 0 c-348 0 -432 -3
-436 -13z"
          />
          <path
            d="M7579 5673 c-12 -27 -52 -129 -91 -228 -38 -99 -107 -274 -153 -390
-46 -115 -99 -253 -119 -305 -20 -52 -41 -105 -46 -118 -6 -13 -10 -25 -10
-27 0 -3 59 -5 130 -5 97 0 130 3 130 13 0 6 15 53 34 102 l34 90 225 3 225 2
31 -81 c17 -45 34 -92 37 -105 6 -24 7 -24 140 -24 l134 0 -9 23 c-5 12 -48
119 -96 237 -124 305 -250 616 -302 748 l-45 112 -114 0 -115 0 -20 -47z m211
-453 c37 -102 66 -188 63 -192 -6 -11 -271 -10 -277 0 -3 4 6 37 18 73 13 35
43 119 67 187 24 67 48 121 53 119 5 -2 39 -86 76 -187z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>; // Render logo without any link
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
